import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import apiClient from '../../services/apiClient';
import SearchableSelectField from './SearchableSelectField';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const Label = styled.label`
  font-size: ${({ theme }) => theme.typography?.sizes?.sm || '0.875rem'};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textSecondary};
  white-space: nowrap;
`;

/**
 * Filtro rápido por sucursal.
 * Props:
 *   value    – string, ID o nombre de la sucursal seleccionada ('' = todas)
 *   onChange – callback(value: string)
 */
export default function FiltroSucursal({ value, onChange }) {
  const [sucursales, setSucursales] = useState([]);

  useEffect(() => {
    apiClient.get('sucursales/')
      .then(res => {
        const data = res.data?.results ?? res.data;
        if (Array.isArray(data)) setSucursales(data);
      })
      .catch(() => {});
  }, []);

  return (
    <Wrapper>
      <Label htmlFor="filtro-sucursal">Sucursal:</Label>
      <div style={{ minWidth: 200, flex: '0 0 200px' }}>
        <SearchableSelectField
          options={sucursales}
          value={value}
          onChange={onChange}
          getOptionValue={(option) => String(option.id)}
          getOptionLabel={(option) => option.nombre || `Sucursal ${option.id}`}
          placeholder="Todas"
          showAllOnFocus
        />
      </div>
    </Wrapper>
  );
}
